import { Box, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AccountCircle as AccountCircleIcon } from '@material-ui/icons';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';

const useStyles = makeStyles({
  textField: {
    width: 80,

    '& > div': {
      height: 32,
      borderRadius: 6,
      paddingRight: 8,
      color: '#a0a0a0',
      fontWeight: 600
    }
  }
});

const iconClasses = 'flex w-10 h-10 justify-center items-center rounded-full shadow-md';

const TeamTipSplitDetails = ({
  avatarUrl,
  firstName,
  lastName,
  isTheSameUser,
  tipBreakdown,
  userId,
  onSplitPercentageChange
}) => {
  const classes = useStyles();
  const intl = useIntl();

  // current user's split percentage
  const splitPercentage = useMemo(
    () => tipBreakdown.find(user => user.userId === userId)?.splitPercentage ?? 0,
    [tipBreakdown]
  );

  // sum of other users' split percentage
  const otherUsersSplitPercentage = useMemo(
    () =>
      tipBreakdown.reduce(
        (acc, { userId: id, splitPercentage }) => acc + (id !== userId ? splitPercentage : 0),
        0
      ),
    [tipBreakdown, userId]
  );

  const handlePercentageChange = event => {
    let newValue = parseFloat(event.target.value);

    // Max allowable value for the current user based on others' percentages
    const remaining = parseFloat((100 - otherUsersSplitPercentage).toFixed(2));

    // Ensure newValue does not exceed remaining
    if (newValue > remaining) {
      newValue = remaining;
    }

    // If incremented with arrow key and there's a remaining fraction part (like .67), ensure it stops at the max
    if (newValue > remaining || newValue < 0) {
      return;
    }

    onSplitPercentageChange({ userId, splitPercentage: newValue });
  };

  return (
    <div className="flex items-center justify-between my-2.5">
      <div className="flex items-center">
        {avatarUrl ? (
          <img className={iconClasses} src={avatarUrl} alt={`${firstName} ${lastName}'s avatar`} />
        ) : (
          <AccountCircleIcon className={`${iconClasses} text-slate-300`} />
        )}
        <div className="ml-4 flex-1 text-slate-700 font-medium">
          {`${firstName} ${lastName}${isTheSameUser ? ' (you)' : ''}`}
        </div>
      </div>
      <Box className="ml-auto">
        <TextField
          label={<Box className="text-[10px] font-semibold text-slate-400 w-[18px]">{intl.formatMessage(messages.split)}</Box>}
          type="number"
          InputProps={{
            endAdornment: '%',
            step: 1 // Step set to 1 for arrow increments
          }}
          value={splitPercentage}
          variant="outlined"
          className={classes.textField}
          onChange={handlePercentageChange}
        />
      </Box>
    </div>
  );
};

export default TeamTipSplitDetails;
